import React from 'react';
import Icon from '../../../components/AppIcon';

const AssetCategoryTabs = ({ activeCategory, onCategoryChange, categoryCounts }) => {
  const categories = [
    { id: 'all', label: 'All Assets', icon: 'Grid3x3' },
    { id: 'logo', label: 'Logos', icon: 'Sparkles' },
    { id: 'technology', label: 'Technology', icon: 'Cpu' },
    { id: 'photo', label: 'Photos', icon: 'Camera' },
    { id: 'diagram', label: 'Diagrams', icon: 'FileText' },
    { id: 'video', label: 'Videos', icon: 'Video' }
  ];

  return (
    <div className="bg-card border border-border rounded-lg p-2 mb-6 overflow-x-auto">
      <div className="flex items-center gap-2 min-w-max">
        {categories?.map((category) => {
          const isActive = activeCategory === category?.id;
          const count = categoryCounts?.[category?.id] || 0;

          return (
            <button
              key={category?.id}
              onClick={() => onCategoryChange(category?.id)}
              className={`flex items-center gap-2 px-4 py-2.5 rounded-lg transition-all duration-250 whitespace-nowrap ${
                isActive
                  ? 'bg-primary text-primary-foreground shadow-sm'
                  : 'text-foreground hover:bg-muted'
              }`}
            >
              <Icon
                name={category?.icon}
                size={18}
                color={isActive ? 'var(--color-primary-foreground)' : 'currentColor'}
              />
              <span className="text-sm font-medium">{category?.label}</span>
              <span
                className={`text-xs px-2 py-0.5 rounded-full ${
                  isActive
                    ? 'bg-primary-foreground/20 text-primary-foreground'
                    : 'bg-muted text-muted-foreground'
                }`}
              >
                {count}
              </span>
            </button>
          );
        })}
      </div>
    </div>
  );
};

export default AssetCategoryTabs;